import { useContainerSize } from '@tunasong/ui-lib'

export const usePixelsPerSecond = (el: HTMLElement | null, duration: number) => {
  const containerSize = useContainerSize(el)
  const width = containerSize?.width ?? 0
  const val = width / duration
  return Number.isNaN(val) ? 1 : val
}
